// Customer wording is a presentation of verified activity and exchange phase.
// These phrases never determine bot state or imply an evaluation is still running.
const PRIMARY = Object.freeze({
  sleeping: 'Resting up for the next trading session.',
  waking: 'Rise and shine! Market opens soon.',
  monitoring: 'On watch for the next opportunity.',
  standby: 'Ready and waiting.',
  preparing: 'Getting everything ready.',
  evaluation_started: 'Strategy evaluation started.',
  working: 'Working through this strategy check.',
  paused: 'Taking a break.',
  fault: 'This bot needs attention.',
  offline: 'Connection lost — this bot needs a fresh update.',
  archived: 'Archived — no longer active.',
  inactive: 'Not active yet.',
  unavailable: 'Activity updates unavailable',
});

const STRATEGY_FOCUS = Object.freeze({
  trend: 'Its strategy looks for pullbacks within a trend.',
  momentum: 'Its strategy looks for momentum after a breakout.',
  reversion: 'Its strategy looks for moves back toward a reference.',
  crossover: 'Its strategy compares shorter and longer trends.',
  breakdown: 'Its strategy looks for downside breakdowns.',
  experiment: 'Its experimental strategy explores pullback setups.',
  classic: 'It follows its saved Classic Technical rules.',
  custom: 'It follows its saved custom strategy.',
});

export const botActivityCopy = (presence, bot) => {
  if (presence.kind === 'monitoring' && bot?.market?.phase === 'open') {
    return 'Analysing the market for potential opportunities.';
  }
  if (presence.kind === 'preparing' && bot?.activity?.animated !== true) {
    return 'Preparation is recorded; a current job is not confirmed.';
  }
  if (bot?.activity?.code === 'preparation_delayed' && presence.kind === 'offline') {
    return 'Preparation needs a fresh update.';
  }
  if (presence.kind === 'inactive') {
    if (bot?.activity?.code === 'stopped') return 'Stopped for now.';
    if (bot?.activity?.code === 'preparation_queued') return 'Preparation requested.';
  }
  return PRIMARY[presence.kind] || PRIMARY.unavailable;
};

export const botStrategyFocus = (personality) => STRATEGY_FOCUS[personality?.key] || STRATEGY_FOCUS.custom;

// Only the durable, verified no-action event receives the conversational title.
export const botTimelineTitle = (item) => item?.event_type === 'MARKET_CHECK_NO_ACTION'
  ? 'Nothing worth acting on just yet.' : item?.title;
